import { render, staticRenderFns } from "./NewsHighlightsSection.vue?vue&type=template&id=16f84cb4&scoped=true&lang=pug"
import script from "./NewsHighlightsSection.vue?vue&type=script&lang=js"
export * from "./NewsHighlightsSection.vue?vue&type=script&lang=js"
import style0 from "./NewsHighlightsSection.styl?vue&type=style&index=0&id=16f84cb4&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f84cb4",
  null
  
)

export default component.exports